import React from "react";
import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Col, Modal, Row } from "react-bootstrap";
import { deleteRequest, postRequest } from "../../api/axiosRequests";
import { BsCheckCircle } from "react-icons/bs";
import { Spinner } from "react-bootstrap";
import AlertModal from "../../common/components/AlertModal";

export default function UserForm({ getCurrentUser, onHide, show, onSubmit }) {
  const [user, setUser] = useState({ id: -1 });
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [cf, setCf] = useState("");
  const [sex, setSex] = useState("M");
  const [height, setHeight] = useState(0);
  const [weight, setWeight] = useState(0);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [isNew, setIsNew] = useState(true);
  const [showDeleteForm, setShowDeleteForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);
  const [loadedDelete, setLoadedDelete] = useState(false);

  const initForm = (userData) => {
    if (userData.id == -1) {
      setFirstname("");
      setLastname("");
      setBirthdate("");
      setCf("");
      setSex("M");
      setHeight(0);
      setWeight(0);
      setEmail("");
      setPassword("");
      setOldPassword("");
      setIsNew(true);
    } else {
      setFirstname(userData.firstname);
      setLastname(userData.lastname);
      setBirthdate(userData.birthdate);
      setCf(userData.cf);
      setSex(userData.sex);
      setHeight(userData.height);
      setWeight(userData.weight);
      setEmail(userData.email);
      setPassword(userData.password);
      setOldPassword(userData.password);
      setIsNew(false);
    }
    setIsLoading(false);
    setIsLoadingDelete(false);
    setLoaded(false);
    setLoadedDelete(false);
  };

  const retrieveUser = () => {
    const data = getCurrentUser();
    setUser(data);
    initForm(data);
  };

  useEffect(() => {
    initForm(user);
  }, []);

  async function userPostRequest(data) {
    const csrftoken = Cookies.get("csrftoken");
    const headers = {
      Authorization: localStorage.getItem("jwt"),
      "X-CSRFToken": csrftoken,
      "Content-Type": "multipart/form-data",
    };
    const response = await postRequest("user/", data, headers);
    return response;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    let formData = new FormData();
    const id = user.id ? user.id : "-1";
    formData.append("id", id);
    formData.append("firstname", firstname);
    formData.append("lastname", lastname);
    formData.append("birthdate", birthdate);
    formData.append("cf", cf);
    formData.append("sex", sex);
    formData.append("height", height);
    formData.append("weight", weight);
    formData.append("email", email);
    const hasPassword = password !== oldPassword ? 1 : 0;
    formData.append("hasPassword", hasPassword);
    formData.append("password", password);
    userPostRequest(formData).then((result) => {
      onSubmit();
      setLoaded(true);
      setIsLoading(false);
      event.target.submit();
    });
  };

  async function deleteCallback(idUser) {
    setIsLoadingDelete(true);
    setShowDeleteForm(false);
    const headers = { Authorization: localStorage.getItem("jwt") };
    let response = deleteRequest("user/" + idUser, headers);
    response.then((result) => {
      setIsLoadingDelete(false);
      setLoadedDelete(true);
      onSubmit();
      onHide();
    });
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      onShow={retrieveUser}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {isNew && "New user"}
          {!isNew && "Update user"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertModal
          show={showDeleteForm}
          getDataId={() => {
            return user.id;
          }}
          onHide={() => {
            setShowDeleteForm(false);
          }}
          onCancel={() => {
            setShowDeleteForm(false);
          }}
          onConfirm={(id) => {
            deleteCallback(id);
          }}
          title={"Delete user"}
          description={"Are you sure you want to delete the user?"}
        />
        <Form
          className="p-2"
          onSubmit={handleSubmit}
          action="/private/adminUsers"
        >
          <div
            style={{
              maxHeight: "300px",
              width: "100%",
              maxWidth: "100%",
              overflowY: "scroll",
              overflowX: "hidden",
            }}
          >
            <div className="m-3">
              <Form.Group className="mb-3">
                <Form.Label>Firstname</Form.Label>
                <Form.Control
                  type="text"
                  autoComplete="name"
                  value={firstname}
                  onChange={(event) => {
                    setFirstname(event.target.value);
                  }}
                  style={{ border: "2px solid #f2f2f2" }}
                  placeholder=""
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Lastname</Form.Label>
                <Form.Control
                  type="text"
                  autoComplete="description"
                  value={lastname}
                  onChange={(event) => {
                    setLastname(event.target.value);
                  }}
                  style={{ border: "2px solid #f2f2f2" }}
                  placeholder=""
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formFirstname">
                <Form.Label>Data di nascità</Form.Label>
                <Form.Control
                  type="date"
                  value={birthdate}
                  onChange={(event) => {
                    setBirthdate(event.target.value);
                  }}
                  style={{ border: "2px solid #f2f2f2" }}
                  placeholder=""
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Codice Fiscale</Form.Label>
                <Form.Control
                  type="text"
                  autoComplete="description"
                  value={cf}
                  onChange={(event) => {
                    setCf(event.target.value);
                  }}
                  style={{ border: "2px solid #f2f2f2" }}
                  placeholder=""
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formFirstname">
                <Form.Label>Sesso</Form.Label>
                <Form.Select
                  aria-label="sex"
                  onChange={(event) => {
                    setSex(event.target.value);
                  }}
                  value={sex}
                >
                  <option key={"M"} value={"M"}>
                    {"Maschio"}
                  </option>
                  <option key={"F"} value={"F"}>
                    {"Femmina"}
                  </option>
                </Form.Select>
              </Form.Group>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Altezza (CM)</Form.Label>
                    <Form.Control
                      type="number"
                      autoComplete="height"
                      value={height}
                      onChange={(event) => {
                        setHeight(event.target.value);
                      }}
                      style={{ border: "2px solid #f2f2f2" }}
                      placeholder=""
                      required
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Peso (KG)</Form.Label>
                    <Form.Control
                      type="number"
                      autoComplete="weight"
                      value={weight}
                      onChange={(event) => {
                        setWeight(event.target.value);
                      }}
                      style={{ border: "2px solid #f2f2f2" }}
                      placeholder=""
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  autoComplete="description"
                  value={email}
                  onChange={(event) => {
                    setEmail(event.target.value);
                  }}
                  style={{ border: "2px solid #f2f2f2" }}
                  placeholder=""
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                  }}
                  style={{ border: "2px solid #f2f2f2" }}
                  placeholder=""
                  required
                />
              </Form.Group>
            </div>
          </div>
          <br />
          <Button
            style={{ width: "100%" }}
            variant="dark"
            type="submit"
            disabled={isLoading || loaded}
          >
            {isLoading && <Spinner animation="border" />}
            {!isLoading && !loaded && "Save"}
            {!isLoading && loaded && <BsCheckCircle size={30} />}
          </Button>
          {!isNew && (
            <div className="mt-2">
              <Button
                style={{ width: "100%" }}
                variant="danger"
                disabled={isLoadingDelete || loadedDelete}
                onClick={() => {
                  setShowDeleteForm(true);
                }}
              >
                {isLoadingDelete && <Spinner animation="border" />}
                {!isLoadingDelete && !loadedDelete && "Delete"}
                {!isLoadingDelete && loadedDelete && (
                  <BsCheckCircle size={30} />
                )}
              </Button>
            </div>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
}
